import { Experiment, Experiments } from '../adobe-target-server-side/types'

export type UIExperience = 'Control' | 'Variant' | 'BAU'

interface ExperimentWithUI extends Experiment {
  actualUIRendered?: UIExperience
  isBAU?: boolean // Flag to mark entries created without Target assignment
}

const experimentsMap: Map<string, ExperimentWithUI> = new Map()

export const setSsrExperiments = (experiments: Experiments): void => {
  const newExperimentNames = new Set(experiments.map(({ name }) => name))

  for (const name of experimentsMap.keys()) {
    if (!newExperimentNames.has(name) && !experimentsMap.get(name)?.isBAU) {
      experimentsMap.delete(name)
    }
  }

  for (const experiment of experiments) {
    const previous = experimentsMap.get(experiment.name)

    if (previous?.experienceId !== experiment.experienceId) {
      experimentsMap.set(experiment.name, {
        ...experiment,
        ...(previous?.isBAU && previous?.actualUIRendered === 'BAU'
          ? { actualUIRendered: previous.actualUIRendered }
          : {}),
      })
    } else {
      experimentsMap.set(experiment.name, {
        ...experiment,
        actualUIRendered: previous?.actualUIRendered,
      })
    }
  }
}

export const getSsrExperiments = (): ExperimentWithUI[] => [
  ...experimentsMap.values(),
]

export const reportActualUIRendered = (
  experimentName: string,
  uiExperience?: UIExperience,
): void => {
  const experiment = experimentsMap.get(experimentName)

  if (experiment) {
    experimentsMap.set(experimentName, {
      ...experiment,
      actualUIRendered: uiExperience,
    })
  } else {
    experimentsMap.set(experimentName, {
      name: experimentName,
      experienceId: 0,
      actualUIRendered: 'BAU',
      isBAU: true,
    })
  }
}

export const getActualUIRendered = (
  experimentName: string,
): UIExperience | undefined =>
  experimentsMap.get(experimentName)?.actualUIRendered

export const resetSsrExperiments = (): void => {
  experimentsMap.clear()
}
